import * as React from 'react';

export const PriceDisplay = ({ price, showCurrency, roundUp }: { price?: number; showCurrency?: boolean; roundUp?: boolean }) => {
    if (typeof price !== 'number') return null;

    const locales = 'nb-NO';

    const priceToDisplay =
        price === parseInt(price.toString(), 10) || roundUp
            ? Math.ceil(price).toLocaleString(locales) + ',-'
            : price.toLocaleString(locales, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
              });

    // replace "small non-breaking space" with a normal space
    const formattedPrice = priceToDisplay.replace(/\u202f/g, ' ');

    return (
        <span className="notranslate">
            {showCurrency && 'kr '}
            {formattedPrice}
        </span>
    );
};
